/** @format */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Family, ContractorService as SesioContractorService } from 'sesio-lib';
import { IDatatableOptions, IDatatableRecords } from '../_components/datagrid/datatable.class';

@Injectable({
  providedIn: 'root',
})
export class ContractorService extends SesioContractorService {
  public datatable(options: { families?: Family[]; query: IDatatableOptions }): Observable<IDatatableRecords<any>> {
    return this.http.post<any>(`${this.config.environment.apiUrl}/contractors/datatable`, options);
  }
}
